<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="14"
    height="14"
    viewBox="0 0 14 14"
  >
    <defs>
      <clipPath id="master_svg0_363_22318">
        <rect x="0" y="0" width="14" height="14" rx="0" />
      </clipPath>
    </defs>
    <g
      style="mix-blend-mode: passthrough"
      clip-path="url(#master_svg0_363_22318)"
    >
      <g style="mix-blend-mode: passthrough">
        <path
          d="M11.374714375,4.661987935211181C11.374714375,4.661987935211181,6.999694375,8.927610935211181,6.999694375,8.927610935211181C6.999694375,8.927610935211181,2.624675375,4.661987935211181,2.624675375,4.661987935211181C2.542716375,4.580029435211181,2.4470493749999997,4.5390501582111815,2.337674375,4.5390501582111815C2.228298375,4.5390501582111815,2.132631375,4.580029435211181,2.050672375,4.661987935211181C1.9687137749999999,4.7439459352111815,1.927734375,4.839612935211182,1.927734375,4.948987935211182C1.927734375,5.058362935211182,1.964192875,5.149508935211181,2.037110375,5.222424935211182C2.037110375,5.222424935211182,6.699134375,9.761480935211182,6.699134375,9.761480935211182C6.781094375,9.843450935211182,6.881424375,9.884420935211182,7.000134375,9.884420935211182C7.118844375,9.884420935211182,7.219174375,9.843450935211182,7.301134375,9.761480935211182C7.301134375,9.761480935211182,11.963134375,5.235987935211182,11.963134375,5.235987935211182C12.036034375,5.154028935211182,12.072534375,5.056028935211182,12.072534375,4.9419879352111815C12.072534375,4.827945935211182,12.031634375,4.732278935211181,11.949634375,4.654987935211182C11.867604375,4.577696135211181,11.771974375,4.538904148211182,11.662594375,4.538612481151182C11.553224375,4.538320814211182,11.457584375,4.5793000352111815,11.375594375,4.661549935211181C11.375594375,4.661549935211181,11.374714375,4.661987935211181,11.374714375,4.661987935211181C11.374714375,4.661987935211181,11.374714375,4.661987935211181,11.374714375,4.661987935211181Z"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'SmallArrowBottom',
} as DefineComponent
</script>
